import React, { Component } from 'react';
import { connect } from 'react-redux';

class Home extends Component {
  render() {
    return (
      <p>Home</p>
    );
  }
}

export default connect((state, props) => {
  return {};
})(Home);



// WEBPACK FOOTER //
// ./src/scenes/Home.js